import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { UploadFile } from '../../upload.service';

@Injectable({
  providedIn: 'root'
})
export class UploadStatusService {

  isOpened = false;
  uploadFiles = [] as UploadFile[];
  uploadStatus = new Subject<UploadFile>();
  
  constructor(private snackBar: MatSnackBar) {
  }

  open(component: ComponentType<unknown>) {
    if (!this.isOpened) {
      const horizontalPosition: MatSnackBarHorizontalPosition = 'end';
      const verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  
      const snackBarRef = this.snackBar.openFromComponent(component, {
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        panelClass: ['file-upload-snackbar']
      });
  
      if (snackBarRef) {
        this.isOpened = true;
      }  
    }
  }

  close() {
    this.isOpened = false;
    this.snackBar.dismiss();
  }

  listen(): Observable<UploadFile> {
    return this.uploadStatus;
  }

  add(uploadFile: UploadFile, component: ComponentType<unknown>) {
    if (uploadFile) {
      if (!this.isOpened) {
        this.uploadFiles = [];
      }
      uploadFile.subject.subscribe(() => {}, () => {}, () => {
        for (const [index, current] of this.uploadFiles.entries()) {
          if (current === uploadFile) {
            this.uploadStatus.next(current);
            break;
          }
        }
      });
      this.uploadFiles.push(uploadFile);

      this.uploadStatus.next(uploadFile);

      if (!this.isOpened) {
        this.open(component);
      }
    }
  }
}
